/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_CreateInputs */

const en_invite_create = /** @type {(inputs: Invite_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite someone`)
};

const de_invite_create = /** @type {(inputs: Invite_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemanden einladen`)
};

/**
* | output |
* | --- |
* | "Invite someone" |
*
* @param {Invite_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_create = /** @type {((inputs?: Invite_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_create(inputs)
	return en_invite_create(inputs)
});